import jwtAuthAxios from "./auth/jwtAuth";

const documentServices = {};

// `index` devuelve { data: [...], head_cells: [...], meta: { current_page, total_pages, ... } }.
//
// Las cabeceras vienen con los datos a proposito: la tabla no tiene las columnas escritas a
// mano, asi que agregar una en el backend no obliga a tocar esta pantalla. Existe ademas
// GET /documents/attributes con solo las cabeceras, por si alguna vista las necesita sueltas.
documentServices.getDocuments = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/documents${params}`);
    return data;
};

// Salud del modulo: cuanto le falta generar, no cuanto le falta al negocio.
documentServices.getHealth = async () => {
    const { data } = await jwtAuthAxios.get("/documents/health");
    return data;
};

// El detalle del pop-up: { summary, documents, receipt, regularization }.
documentServices.getDeliveryDocuments = async (deliveryId) => {
    const { data } = await jwtAuthAxios.get(`/documents/${deliveryId}`);
    return data;
};

// slot: "original" (el documento sin firmar) o "signed" (el firmado en papel).
documentServices.uploadDocument = async (deliveryId, file, slot) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("slot", slot);

    const { data } = await jwtAuthAxios.post(`/documents/${deliveryId}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

documentServices.destroyDocument = async (deliveryId, shippingDocId) => {
    const { data } = await jwtAuthAxios.delete(`/documents/${deliveryId}/files/${shippingDocId}`);
    return data;
};

documentServices.updateDocumentType = async (deliveryId, typeOfDocument) => {
    const { data } = await jwtAuthAxios.patch(`/documents/${deliveryId}/document_type`, {
        type_of_document: typeOfDocument,
    });
    return data;
};

documentServices.saveRegularization = async (deliveryId, payload) => {
    const { data } = await jwtAuthAxios.post(`/documents/${deliveryId}/regularization`, {
        regularization: payload,
    });
    return data;
};

// Descarga en ZIP de los P.O.D. que muestran los filtros vigentes.
//
// `arraybuffer` y no json: la respuesta es binaria. El backend contesta 422 con un mensaje
// cuando la seleccion supera el tope, asi que el caller tiene que leer el error como texto.
documentServices.exportPods = async (params = "") => {
    const response = await jwtAuthAxios.get(`/documents/export${params}`, { responseType: "arraybuffer" });
    return response;
};

documentServices.regenerate = async (deliveryId) => {
    const { data } = await jwtAuthAxios.post(`/documents/${deliveryId}/regenerate`);
    return data;
};

export default documentServices;
